import React, { useState } from 'react';
import RAGDocumentManager from './RAGDocumentManager';
import BlockGeneratorManager from './blocks/BlockGeneratorManager';

/**
 * RagAndBlocksTab
 *
 * Thin wrapper that combines the existing RAG Document Manager and the new
 * Block Generator into two sub-tabs.  GuideBuilder renders this component
 * wherever it previously rendered <RAGDocumentManager> directly.
 *
 * Props mirror those previously passed to RAGDocumentManager so callers
 * need no changes beyond the import swap.
 */
const RagAndBlocksTab = ({ itinerary, setItinerary, onStatusChange }) => {
  const [activeSubTab, setActiveSubTab] = useState('rag');

  const subTabClass = (tab) =>
    `px-5 py-2.5 text-sm font-medium border-b-2 transition-colors ${
      activeSubTab === tab
        ? 'border-blue-600 text-blue-600 bg-white'
        : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300'
    }`;

  return (
    <div>
      {/* Sub-tab navigation */}
      <div className="flex border-b border-gray-200 mb-6">
        <button onClick={() => setActiveSubTab('rag')} className={subTabClass('rag')}>
          📄 RAG Documents
        </button>
        <button onClick={() => setActiveSubTab('blocks')} className={subTabClass('blocks')}>
          ⚡ Audio Blocks
        </button>
      </div>

      {/* Sub-tab content */}
      {activeSubTab === 'rag' && (
        <RAGDocumentManager
          itinerary={itinerary}
          setItinerary={setItinerary}
          onStatusChange={onStatusChange}
        />
      )}

      {activeSubTab === 'blocks' && (
        <BlockGeneratorManager
          itinerary={itinerary}
          setItinerary={setItinerary}
          onStatusChange={onStatusChange}
        />
      )}
    </div>
  );
};

export default RagAndBlocksTab;
